// extracted by mini-css-extract-plugin
module.exports = {"moderator-badge":"ModeratorBadge_moderator-badge__JO9S4"};